<!-- 底部导航 -->
<template>
    <div
        v-if="componentsData.type == 26"
        class="bg-div"
        :style="
            componentsData.content.version
                ? {
                      ...(componentsData.content.bg_color && {
                          backgroundColor: componentsData.content.bg_color,
                      }),
                      ...(componentsData.content.bg_img.picview &&
                          componentsData.content.bg_value && {
                              backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                          }),
                  }
                : `background: ${componentsData.content.bg_color};`
        "
    >
        <div
            :class="
                componentsData.content.iconList.length > 1
                    ? 'flex-sb'
                    : 'flex-c'
            "
            class="overflow-hidden"
        >
            <div
                class="icon-div"
                v-for="(item, index) of componentsData.content.iconList"
                :key="index"
            >
                <img :src="item.img_list.picview" class="wh24" />
                <div
                    class="txt-container"
                    :style="`color: ${componentsData.content.txt_color};`"
                >
                    {{ item.txt }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}

.icon-div {
    width: 33.333%;
    height: 58px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

.wh24 {
    width: 24px;
    height: 24px;
}

.txt-container {
    margin-top: 3px;
    font-size: 13px;
}
</style>